import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=53f07039&scoped=true&"
import script from "./Newsletter.vue?vue&type=script&lang=ts&"
export * from "./Newsletter.vue?vue&type=script&lang=ts&"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=53f07039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f07039",
  null
  
)

export default component.exports